import styled from 'styled-components';

export const Text = styled.p`
  font-size: 0.80rem;
  font-weight: initial;

  color: ${({ theme }) => theme.colors.gray[600]};

  margin-bottom: 4px;

  display: flex;
  align-items: center;
  gap: 4px;
`;
